var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "horizontal-table-container",
      class: {
        "horizontal-table-container--scroll": _vm.hasScroll,
        "horizontal-table-container--end": _vm.end,
      },
    },
    [
      _c("perfect-scrollbar", { ref: "scroll", on: { scroll: _vm.scroll } }, [
        _c(
          "div",
          {
            ref: "container",
            staticClass: "horizontal-table-container__scroll",
          },
          [
            _vm._t("default"),
            _c("div", {
              ref: "observer",
              staticClass: "horizontal-table-container__observer",
            }),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }